
import React from "react";

const points = [
  "Includes Full Water Purifier Checkup",
  "Service & spare part charges extra as per rate card",
  "Save Upto 50% on Annual Maintainence (AMC)",
  "Branded & Non-Branded RO Authentic Service",
  "Installation, Repair & Relocation Services"
];

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <h1 className="hero-title">
              <span className="title-box">RO Service Provider</span><br />
              at Your Doorstep
            </h1>

            <p className="offer">Quick Service</p>

            <ul className="hero-list list-unstyled">
              {points.map((item, index) => (
                <li key={index}>
                  <span>✔</span> {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-lg-6">
            <img
              src="images/banner-bg.webp"
              alt="banner"
              className="hero-image"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
